// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"WithPublicToken__fullScreenLoader___Dj1WA"};